/**
 * #19351: localStorage key prefix under which the e-mail-verification notice remembers that a user closed it
 * (`<prefix><username>`). Kept dependency-free so the Playwright fixtures can import it as well.
 */
export const EMAIL_HINT_SNOOZE_KEY_PREFIX = "reva_email_hint_snoozed_";
